module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoice-box"
  }, [_c('div', {
    staticClass: "ls-float-left col-md-12 col-xs-12 col-sm-12 col-lg-12 ls-box"
  }, [_c('h3', {
    staticClass: "ls-title"
  }, [_vm._v(_vm._s(_vm.$t('payments.attributes.invoice')) + " nº " + _vm._s(_vm.invoiceNumber()))]), _vm._v(" "), _c('p', {
    staticClass: "ls-title"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.due') + _vm.date.parseDate(_vm.invoice.due_date)))]), _vm._v(" "), _c('hr', {
    staticClass: "ls-no-margin-bottom"
  }), _vm._v(" "), (_vm.invoice.invoice_items) ? _c('div', {
    staticClass: "box-scroll"
  }, _vm._l((_vm.invoice.invoice_items.filter(function (item) { return item.active; })), function(invoice_item, index) {
    return _c('div', [_c('p', {
      staticClass: "main-text"
    }, [_vm._v(_vm._s(invoice_item.description))]), _vm._v(" "), (_vm.showItemType()) ? _c('p', [_vm._v(_vm._s(invoice_item.resource_label))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.validity(invoice_item)))]), _vm._v(" "), _c('p', [_vm._v("R$" + _vm._s(_vm.money.parseViewValue(invoice_item.price)))]), _vm._v(" "), (index < _vm.invoice.invoice_items.length - 1) ? _c('hr', {
      staticClass: "ls-no-margin-top"
    }) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "ls-no-margin-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "ls-md-margin-top"
  }, [_vm._v(_vm._s(_vm.$t('payments.attributes.amount_due')) + ": R$ " + _vm._s(_vm.money.parseViewValue(_vm.invoice.amount_due)))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7aaa7204"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/payments/components/InvoiceDetails.vue
// module id = 808
// module chunks = 1